import { Attachment } from './question'
import { AnswerSkipReasonEnum } from '../enums/answer-skip-reason.enum'

export interface AnswerT {
  questionId: number
  answer?: string | number | boolean | string[] | Attachment | undefined
  skipped: boolean
  skipReason?: AnswerSkipReasonEnum
  weight: number
  max?: number
  min?: number
  suggestedAnswer?: number | string
}

export const getAnswerSkipReason = (
  answer?: { skipReason?: AnswerSkipReasonEnum; skipped?: boolean } | null
): AnswerSkipReasonEnum | undefined => {
  if (answer?.skipReason) {
    return answer.skipReason
  }

  if (answer?.skipped) {
    return AnswerSkipReasonEnum.NOT_APPLICABLE
  }

  return undefined
}

export const isAnswerSkipped = (answer?: { skipReason?: AnswerSkipReasonEnum; skipped?: boolean } | null): boolean =>
  getAnswerSkipReason(answer) !== undefined
